import React, { useState, useContext, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { ThemeContext } from '../../context/ThemeContext';

const MainLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    try {
      const stored = localStorage.getItem('isSidebarOpen');
      return stored ? JSON.parse(stored) : true;
    } catch (e) {
      return true;
    }
  });
  const { theme } = useContext(ThemeContext);

  // Persist sidebar state
  useEffect(() => {
    try {
      localStorage.setItem('isSidebarOpen', JSON.stringify(isSidebarOpen));
    } catch (e) {
      // ignore
    }
  }, [isSidebarOpen]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`flex h-screen transition-colors duration-200 ${theme === 'dark' ? 'bg-slate-900' : 'bg-gray-100'}`}>
      <Sidebar isSidebarOpen={isSidebarOpen} />
      <div className={`
        flex-1 flex flex-col overflow-hidden
       
        transition-all duration-300 ease-in-out
      `}>
        <Header toggleSidebar={toggleSidebar} />
        <main className={`flex-1 overflow-x-hidden overflow-y-auto ${theme === 'dark' ? 'bg-slate-800' : 'bg-gray-200'}`}>
          <div className="container mx-auto px-6 py-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
